module.exports = __webpack_public_path__ + "img/no_picture_available.2246dc72.png";